import { Payment, description} from "../zugferd_2_3_2/payment"
export { Payment, description }